
import { buildDeviceLabel, getOrCreateDeviceId } from '../auth/deviceId'

export const authDevicePayload = () => ({
  device_id: getOrCreateDeviceId(),
  device_label: buildDeviceLabel(),
})
